var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 10.867 2.467 17.4q-.367.367-.934.367-.566 0-.933-.367-.366-.366-.367-.933 0-.567.367-.934L7.133 9 .6 2.467Q.234 2.1.233 1.533.233.968.6.6q.367-.367.933-.367T2.467.6L9 7.133 15.533.6q.367-.366.934-.367.566 0 .933.367t.367.933-.367.934L10.867 9l6.533 6.533q.367.367.367.934t-.367.933-.933.367-.934-.367z"
  })));
};
export default SvgCross;